module.exports = __webpack_public_path__ + "img/1.670c7eef.670c7eef.gif";